export default {
  rules_no_points_month: 'No points for this month',
  rules_description_title: 'Credit rule description:',
  rules_description01: '1. Total credits: the total of all kinds of credits obtained, associated with the rank system.' ,
  rules_description02: '2. Credit type: According to the source of credit acquisition, classified as "Learning credits", "Contribution credits", "Anchor credits", "Micro-course credits", "Instructor credits", "Interactive credits", you can filter to see the details.' ,
  rules_description03: '3. Point limit: Show the daily limit of each credit.' ,
  rules_description04: '4. Some event behaviors are temporarily only supported to get credits in App side.' ,

  rules_description_detail: 'Credit rule details',
  rules_sort: 'Serial No.',
  rules_behavior: 'Event behavior',
  rules_score: 'Single score (credits)',
  rules_description_type: 'Note',
  rules_type_title: 'Type',
  rules_maximum_points: 'Credit limit (daily):'
}
